import { Layout } from "@/components/Layout";
import { Mail, MessageCircle } from "lucide-react";

const EMAIL_USER = "hello";
const EMAIL_DOMAIN = "yourracefinder.com";

export default function Contact() {
  const openEmail = (e) => {
    e.preventDefault();
    window.location.href = `mailto:${EMAIL_USER}@${EMAIL_DOMAIN}`;
  };

  return (
    <Layout>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16">
        <h1 className="font-display font-extrabold uppercase tracking-wide text-4xl text-[#0f172a]">Contact Us</h1>
        <p className="text-slate-600 mt-4">Questions about a race listing or your account? We're here to help.</p>
        <div className="grid sm:grid-cols-2 gap-4 mt-8">
          <a href="#" onClick={openEmail} data-testid="contact-email-link" className="flex items-center gap-3 p-5 bg-white border border-slate-200 rounded-xl hover:border-[#22d3ee]">
            <Mail className="text-[#06b6d4]" /><div><div className="font-semibold text-slate-800">Email</div><div className="text-sm text-slate-500">Click to email us</div></div>
          </a>
          <a href="https://wa.me/60102207962" target="_blank" rel="noreferrer" data-testid="contact-whatsapp-link" className="flex items-center gap-3 p-5 bg-white border border-slate-200 rounded-xl hover:border-[#22d3ee]">
            <MessageCircle className="text-[#25D366]" /><div><div className="font-semibold text-slate-800">WhatsApp</div><div className="text-sm text-slate-500">Chat with us on WhatsApp</div></div>
          </a>
        </div>
      </div>
    </Layout>
  );
}
